import React, { FC, RefObject, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle } from 'styled-components';

import { ClosePopup, Container, Header, Popup, PopupWrapper } from './styled';

const GlobalStyle = createGlobalStyle<{isPopupOpen?: boolean}>`
    body {
        overflow: ${props => props.isPopupOpen ? 'hidden' : 'auto'}
    }
`;

const ID_POPUP_ROOT = 'popup-wrapper';

interface PopupWithHeaderProps {
    isOpen: boolean,
    onClose: () => void,
    width?: string,
    height?: string,
    fullWidth?: boolean,
    color?: string,
    backgroundColor?: string,
    closeColor?: string,
    className?: string,

    // ...rest
    [key: string]: any,
}

const PopupWithHeader: FC<PopupWithHeaderProps> = ({
    onClose,
    isOpen,
    backgroundColor,
    width,
    height,
    closeColor,
    fullWidth,
    className,
    headerContent,
    children,
}): JSX.Element => {
    const [popupRoot, setPopupRoot] = useState<null | HTMLElement>(null);
    const popupArea = React.createRef();
    const [popupOpen, setPopupOpen] = useState(false);

    const initPopupRoot = () => {
        if (typeof window !== 'undefined' && popupRoot === null) {
            let root = document.getElementById(ID_POPUP_ROOT);
            if (!root) {
                root = document.createElement('div');
                root.setAttribute('id', ID_POPUP_ROOT);
                document.body.appendChild(root);
            }
            setPopupRoot(root);
        }
    };

    useEffect(() => {
        initPopupRoot();
    }, []);

    useEffect(() => {
      if (!popupOpen && isOpen) {
        setPopupOpen(true);
      } else if (popupOpen && !isOpen) {
        setPopupOpen(false);
      }
      initPopupRoot();
    }, [isOpen]);

    const closePopupFromWrapper = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target == popupArea.current) {
            onClose();
        }
    };

    const popup = isOpen
        ? <PopupWrapper>
            <Container onClick={closePopupFromWrapper} ref={popupArea as RefObject<HTMLDivElement>}>
                <Popup
                    color={backgroundColor}
                    // @ts-ignore
                    width={width}
                    height={height}
                    fullWidth={fullWidth}
                    className={className}>
                    <Header>{headerContent}</Header>
                    <ClosePopup color={closeColor} onClick={onClose}/>
                    {children}
                </Popup>
            </Container>
        </PopupWrapper>
        : null;

    return <>
        {popupRoot !== null &&
        <React.Fragment>
            <GlobalStyle isPopupOpen={popupOpen}/>
            {ReactDOM.createPortal(popup, popupRoot)}
        </React.Fragment>
        }
    </>;
};

export default PopupWithHeader;
